export default {
  common: {
    nav: {
      home: "హోమ్",
      find_offer_help: "సహాయాన్ని కనుగొనండి / ఇవ్వండి",
      celebrate: "జీవితాన్ని ఆనందించండి",
      family_tree: "కుటుంబ వృక్షం",
      events: "కార్యక్రమాలు",
      civic_reports: "పౌర నివేదికలు",
      neighborhood_pulse: "పొరుగు స్పందన",
      weather: "వాతావరణం",
      nature: "ప్రకృతి",
      marketplace: "మార్కెట్",
      news: "వార్తలు",
      causes: "లక్ష్యాలు",
      more: "మరిన్ని",
    },
    header: { sign_in: "సైన్ ఇన్", join: "Social Pulse లో చేరండి", language: "భాష", search: "శోధించండి" },
    tagline: "సమాజాలను కలుపుతూ · జీవితాలను శక్తివంతం చేస్తూ · సామాజిక మూలధనం నిర్మిస్తూ",
    locality: { viewing_from: "మీరు చూస్తున్నారు", change: "మార్చండి", set_your_location: "మీ స్థానాన్ని సెట్ చేయండి" },
    news: { title: "మీ రోజువారీ సారాంశం.", play_briefing: "రోజువారీ సారాంశాన్ని ప్లే చేయండి", listen: "వినండి", translate: "అనువదించండి" },
  },
};
